import { Serializable } from "./serializable";

export class Locales implements Serializable<Locales> {
  id: number | null = null;
  label: string = "";
  icon: string = "";
  active: boolean = false;

  deserialize(input: any): Locales {
    if (input != null) {
      this.id = input.iso2;
      this.label = input.label || "";
      this.icon = `${input.iso2}.png` || "";
      this.active = input.active || false;
    }
    return this;
  }
}
